const template = {
  6: [
    { x: 0, y: 0, w: 6, h: 2, component: 'Content', withExtra: true },
  ],
  4: [
    { x: 0, y: 0, w: 4, h: 2, component: 'Content', withExtra: true },
  ],
  2: [
    { x: 0, y: 0, w: 2, h: 2, component: 'Content', withExtra: true },
  ],
  1: [
    { x: 0, y: 0, w: 1, h: 1, component: 'Shape' },
  ]
}

const initialTemplate = {
  6: [
    { x: 0, y: 0, w: 6, h: 2, component: 'Content' },
  ],
  4: [
    { x: 0, y: 0, w: 4, h: 2, component: 'Content' },
  ],
  2: [
    { x: 0, y: 0, w: 2, h: 2, component: 'Content' },
  ],
  1: [
    { x: 0, y: 0, w: 1, h: 1, component: 'Shape' },
  ]
}

const footer = {
  6: [
    { x: 0, y: 0, w: 4, h: 1, component: 'ContactProgram' },
    { x: 4, y: 0, w: 2, h: 1, component: 'Newsletter' },
  ],
  4: [
    { x: 0, y: 0, w: 2, h: 1, component: 'ContactProgram' },
    { x: 2, y: 0, w: 2, h: 1, component: 'Newsletter' },
  ],
  2: [
    { x: 0, y: 0, w: 2, h: 1, component: 'Announcement' },
  ],
  1: [
    { x: 0, y: 0, w: 1, h: 1, component: 'Shape' },
  ]
}



const getTemplate = (templateString = 'main') => {
  switch (templateString) {
    case 'main': return template
    case 'initialTemplate': return initialTemplate
    case 'footer': return footer
    default: return template
  }
}

export default getTemplate